<template>
    <base-modal
        @close="close"
        class="cz2__ai-preview-modal"
    >
        <div class="cz2__ai-preview-modal-content">
            <div class="cz2__modal-popup__header">
                {{ $t('AI_PREVIEW_HEADING') }}
            </div>

            <p
                v-html="$t('AI_PREVIEW_COPY')"
                class="cz2__modal-popup__copy"
            />

            <div
                :style="{
                    backgroundImage: `url(${popSnapshot})`,
                }"
                class="cz2__ai-preview-modal-image"
            />

            <div class="cz2__ai-modal__buttons">
                <btn
                    primary
                    @click="accept"
                >
                    {{ $t('AI_PICK_OUTFIT') }}
                </btn>

                <btn
                    black
                    @click="loadBodyStep"
                >
                    {{ $t('AI_CHANGE_APPEARANCE') }}
                </btn>

                <btn
                    gray
                    @click="startOver"
                >
                    {{ $t('AI_START_OVER') }}
                </btn>
            </div>
        </div>
    </base-modal>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-preview-modal-content {
            padding: 32px;
            max-width: 450px;
            display: flex;
            flex-direction: column;
            text-align: center;

            .cz2__ai-preview-modal-image {
                height: 270px;
                width: 100%;

                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
            }
        }
    }
</style>

<script>
    import BaseModal from '../ui/BaseModal.vue';
    import Btn from '../ui/Btn.vue';

    export default {
        components: {
            BaseModal,
            Btn,
        },

        data() {
            return {
                popSnapshot: null,
            };
        },

        computed: {
            navigableGroups() {
                return this.$store.getters.navigationGroups;
            },
        },

        mounted() {
            // Wait for renderer to load.
            this.emitter.$on('cameraLoading', this.cameraLoading);

            this.takeSnapshotIfNotLoading();

            // Make sure the AI modal is closed
            this.$store.dispatch('showAiModal', false);
        },

        beforeDestroy() {
            this.emitter.$off('cameraLoading', this.cameraLoading);

            this.close();
        },

        methods: {
            accept() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-accept',
                });

                this.close();
            },

            close() {
                this.$store.dispatch('showAiPreviewModal', false);

                // Reset since we're done with the preview modal.
                this.$store.dispatch('setBuiltFromSelfie', false);
            },

            loadBodyStep() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-change',
                });

                this.$store.dispatch('showGroup', this.navigableGroups[0]);
                this.close();
            },

            startOver() {
                this.$store.state.customizer.mainController.trackAction({
                    action: 'ai-selfie-restart',
                });

                window.location.reload();
            },

            cameraLoading(loading) {
                if (!loading) {
                    this.takeSnapshotIfNotLoading();
                }
            },

            takeSnapshotIfNotLoading() {
                console.log('[AI] Take a picture...');

                // Check if renderer is still loading.
                // Delay the check by a few just in case the camera loader restarts.
                // Not a big deal if this fires again. We will just take more pics.
                setTimeout(() => {
                    this.emitter.$emit('isCameraLoading', (isLoading) => {
                        if (!isLoading) {
                            console.log('[AI] Getting snapshot...');

                            // Get snapshot if renderer is done
                            this.getSnapshot();
                        } else {
                            console.log('[AI] Still loading...');
                        }
                    });
                }, 100);
            },

            async getSnapshot() {
                const popSnapshot = await this.$store.dispatch('snapshot', {
                    view: 'SnapshotNarrow',
                    onlyController: this.viewController,
                });

                this.popSnapshot = popSnapshot;
            },
        },
    };
</script>
